import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

export function RollupX({ sx, testId, ...props }: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("RollupX");
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 33 32"
      testId={testId}
      sx={mergeSx({ w: "200px" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}

RollupX.displayName = "RollupX";
